export default "__VITE_ASSET__yv8W89Ny__"